import { render } from "./LoadingSpannier.vue?vue&type=template&id=6969ba65&scoped=true"
const script = {}

import "./LoadingSpannier.vue?vue&type=style&index=0&id=6969ba65&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6969ba65"]])

export default __exports__